import { VariantProps, cva } from 'class-variance-authority';

export const avatarStyles = cva(['overflow-hidden bg-primary100 select-none'], {
  variants: {
    variant: {
      circular: ['rounded-full'],
      rounded: [],
      square: [],
    },
    size: {
      16: ['min-w-16 w-16 h-16'],
      24: ['min-w-24 w-24 h-24'],
      32: ['min-w-32 w-32 h-32'],
      40: ['min-w-40 w-40 h-40'],
      48: ['min-w-48 w-48 h-48'],
    },
  },
  compoundVariants: [
    {
      variant: ['rounded'],
      size: [16],
      className: 'rounded-2',
    },
    {
      variant: ['rounded'],
      size: [24, 32, 40, 48],
      className: 'rounded-12',
    },
  ],
  defaultVariants: {
    variant: 'circular',
    size: 32,
  },
});

export type AvatarStyleVariants = VariantProps<typeof avatarStyles>;
